import { render, staticRenderFns } from "./DashboardAccordionLazyTabs.vue?vue&type=template&id=daea51f8"
import script from "./DashboardAccordionLazyTabs.vue?vue&type=script&lang=js"
export * from "./DashboardAccordionLazyTabs.vue?vue&type=script&lang=js"
import style0 from "./DashboardAccordionLazyTabs.vue?vue&type=style&index=0&id=daea51f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports